module.exports = __webpack_public_path__ + "static/media/icon-go.6480d7ba.svg";